import Phaser from 'phaser'
import { createCharacterAnims } from '../anims/CharacterAnims'
import { createChestAnims } from '../anims/TreasureAnims'

export default class Game extends Phaser.Scene
{
	constructor()
	{
		super('title')
	}

	preload()
    {
    }

    create()
    {
        createCharacterAnims(this.anims)

        const c = 290
        const btn = this.add.text(180, c, 'start', { fontFamily: 'Monospace', fontSize: 16, fill: '#ffffff', boundsAlignH: "center", boundsAlignV: "middle" });

        const a = 330
        this.add.text(100, a, "Press SPACEBAR to begin", { fontFamily: 'Monospace', fontSize: 12, fill: '#eee', boundsAlignH: "center", boundsAlignV: "middle" });
        this.add.text(100, a+13, "Arrows to move player around", { fontFamily: 'Monospace', fontSize: 12, fill: '#eee', boundsAlignH: "center", boundsAlignV: "middle" });
        this.add.text(100, a+26, "'Q' and 'W' to add and remove NPCs", { fontFamily: 'Monospace', fontSize: 12, fill: '#eee', boundsAlignH: "center", boundsAlignV: "middle" });

        const b = 165
        this.add.text(100, b-10, "In this land,", { fontFamily: 'Monospace', fontSize: 10, fill: '#ffffff70', boundsAlignH: "center", boundsAlignV: "middle" });
        this.add.text(100, b+10, "Mempools are bottomless", { fontFamily: 'Monospace', fontSize: 10, fill: '#ffffff70', boundsAlignH: "center", boundsAlignV: "middle" });
        this.add.text(100, b+20, "Miners are relentless", { fontFamily: 'Monospace', fontSize: 10, fill: '#ffffff70', boundsAlignH: "center", boundsAlignV: "middle" });
        this.add.text(100, b+40, "And NPCs are polite", { fontFamily: 'Monospace', fontSize: 10, fill: '#ffffff70', boundsAlignH: "center", boundsAlignV: "middle" });
        this.add.text(100, b+50, "For they pay when collide", { fontFamily: 'Monospace', fontSize: 10, fill: '#ffffff70', boundsAlignH: "center", boundsAlignV: "middle" });
        this.add.text(100, b+70, "But beware: too many, transactions linger", { fontFamily: 'Monospace', fontSize: 10, fill: '#ffffff70', boundsAlignH: "center", boundsAlignV: "middle" });
        this.add.text(100, b+80, "too few, no rewards", { fontFamily: 'Monospace', fontSize: 10, fill: '#ffffff70', boundsAlignH: "center", boundsAlignV: "middle" });

        this.cameras.main.backgroundColor = Phaser.Display.Color.HexStringToColor("#5a9e29");

        this.add.sprite(190, 100, 'title')
        const farmer = this.add.farmer(0, c+5, 'farmer')
        console.dir(farmer)
        farmer.anims.play('farmer-walk-right')
        farmer.setVelocityX(160)
        this.time.delayedCall(1000, () => {
          farmer.setVelocityX(0)
          farmer.anims.play('farmer-idle-down')
        })
        btn.setInteractive();
        btn.on('pointerover', () => btn.setStyle('#ff0'))
        btn.on('pointerout', () => btn.setStyle('#0f0'))
        btn.on('pointerdown', () => this.scene.start('game'));
        this.input.keyboard.on('keydown', event => {
            event.preventDefault();
            if (event.keyCode==32)
                this.scene.start('game');
        });
   }
}
